import AttachmentsList from 'components/AttachmentsList'
import React from 'react'
import styles from './styles'

function DisplayAddress(props) {
  const { questionData } = props
  const classes = styles()

  const buildTermsAgreement = (questionInfo) => {
    const { answer, has_answer } = questionInfo
    return (
      <div className={classes.answersContainer}>
        {has_answer ? (
          <React.Fragment>
            <p>
              <span>CEP: </span>
              {answer.zipcode}
            </p>
            <p>
              <span>Estado: </span>
              {answer.state}
            </p>
            <p>
              <span>Cidade: </span>
              {answer.city}
            </p>
            <p>
              <span>Bairro: </span>
              {answer.zipcode}
            </p>
            <p>
              <span>Endereço: </span>
              {`${answer.address}, ${answer.house_number}`}
            </p>
            {answer.complement && (
              <p>
                <span>Complemento: </span>
                {answer.complement}
              </p>
            )}
            <AttachmentsList attachments={answer.attachments} title="Comprovante de residência:"/>
          </React.Fragment>
        ) : (
          <p>A questão ainda não foi respondida</p>
        )}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Endereço Residencial:</h3>
      {buildTermsAgreement(questionData)}
    </div>
  )
}

export default DisplayAddress
